var eurowater = eurowater || {};
( function () {
    'use strict';
    eurowater.handlebars = {
        testValue: function ( v1, operator, v2 ) {
            switch ( operator ) {
                case '===':
                    return ( v1 === v2 );
                case '!==':
                    return ( v1 !== v2 );
                case '<':
                    return ( v1 < v2 );
                case '<=':
                    return ( v1 <= v2 );
                case '>':
                    return ( v1 > v2 );
                case '>=':
                    return ( v1 >= v2 );
                case '&&':
                    return ( v1 && v2 );
                case '||':
                    return ( v1 || v2 );
                case '!!':
                    return ( !v1 && !v2 );
                case '!|':
                    return ( !v1 && v2 );
                case '|!':
                    return ( v1 && !v2 );
                default:
                    return false;
            }
        },
        helpers: {
            compare_extended: function () {
                Handlebars.registerHelper( 'compare_extended', function ( v1, operator, v2, options ) {
                    if ( v2.indexOf( ',' ) > -1 ) {
                        // v2 is array - extend compare-function
                        var v2Arr       = v2.split( ',' ),
                            v2ReturnArr = [];
                        // iterate v2-array and test each value, adding the returned boolean to a temp array
                        for ( var i = 0; i < v2Arr.length; i++ ) {
                            v2ReturnArr.push( eurowater.handlebars.testValue( v1, operator, v2Arr[ i ] ) );
                        }
                        // test temp array values, returning true if all values are the same, eg. [true,true] or
                        // [false,false]
                        return v2ReturnArr.every( function ( val ) {
                            return val
                        } ) === true ? options.fn( this ) : options.inverse( this );
                    }
                    else {
                        // v2 is string - standard compare function
                        return eurowater.handlebars.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
                    }
                } );
            },
            each_with_sort: function () {
                Handlebars.registerHelper( 'each_by_dates', function ( context, key, options ) {
                    var output = '';
                    var contextSorted = context.concat()
                            .sort( function(a,b) { return new Date(b[key]) - new Date(a[key])} );
                    for(var i=0, j=contextSorted.length; i<j; i++) {
                        output += options.fn(contextSorted[i]);
                    }
                    return output;
                } );
            }
        }
    };
}() );
